export default __webpack_public_path__ + "static/media/DSC_0854.5b8eaec0.JPG";